import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { canVisit, defaultRoute, hasAccess } from "../utils/accessPolicy";

export function useAccess() {
  const authorization = useSelector((state: RootState) => state.auth.authorization);
  return {
    authorization,
    isSuperAdmin: authorization?.isSuperAdmin === true,
    can: (permission: string) => hasAccess(authorization, { allOf: [permission] }),
    canAny: (...permissions: string[]) => hasAccess(authorization, { anyOf: permissions }),
    canVisit: (path: string) => canVisit(path, authorization),
    landingPage: defaultRoute(authorization),
  };
}
